import { Trans, useTranslation } from 'react-i18next';
import LegalPage from '@/components/legal/LegalPage';

export default function TermsPage() {
  const { t } = useTranslation();
  const sections = t('legal.terms.sections', { returnObjects: true }) || [];
  const updated = t('legal.lastUpdated');

  return (
    <LegalPage titleKey="legal.terms.title" testIdSuffix="terms">
      <p className="text-sm text-muted-foreground mb-6">{updated}</p>
      <p>{t('legal.terms.intro')}</p>

      {Array.isArray(sections) && sections.map((s, i) => (
        <section key={i} className="mt-6">
          <h2 className="text-lg font-semibold mt-6 mb-2 text-foreground" style={{ fontFamily: 'Outfit' }}>
            {s.heading}
          </h2>
          {(s.paragraphs || []).map((p, j) => (
            <p key={j} className="mb-2">{p}</p>
          ))}
          {Array.isArray(s.list) && s.list.length > 0 && (
            <ul className="list-disc pl-6 mb-2 space-y-1">
              {s.list.map((it, k) => <li key={k}>{it}</li>)}
            </ul>
          )}
        </section>
      ))}

      <p className="mt-8 text-sm text-muted-foreground">
        <Trans
          i18nKey="legal.contactLine"
          components={{
            mail: <a className="underline hover:text-foreground" href="mailto:offertes@powersure-worldwide.com" />,
          }}
        />
      </p>
    </LegalPage>
  );
}
